import Input from './input'
import SharedLinks from './shared_links'

class Modal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      helperObject: this.props.helperObject || {},
      paymentDate: new Date().toISOString().split('T')[0]
    }
  }

  componentDidMount() {
    jQuery('#modal').modal()
    window.magnify()
  }

  componentDidUpdate(prevProps) {
    jQuery('#modal').modal()
    window.magnify()
  }

  handleRefresh(e) {
    e.preventDefault()
    window.location.reload()
  }

  handleHelperInputChange(e) {
    let h = {}
    h[e.target.name] = e.target.type == 'checkbox' ? e.target.checked : e.target.value
    let helperObject = Object.assign({}, this.state.helperObject, h)
    this.setState({
      helperObject: helperObject
    })
  }

  toggleInvoicePaid(e) {
    e.preventDefault()

    let data = {
      invoice: {
        paid: !this.props.helperObject.paid
      }
    }

    if (!this.props.helperObject.paid) {
      data.invoice.payment_date = this.state.paymentDate
    }

    jQuery.ajax({
      method: 'PATCH',
      url: this.props.helperObject.url,
      dataType: 'script',
      data,
      beforeSend: () => {
        this.props.table.setState({ loading: true })
        jQuery('#modal').modal('hide')
      }
    })
  }

  render() {
    let body
    let footer
    switch (this.props.scenario) {
      case 'create-invoice-from-transfers':
        let params = {
          vat_included: this.state.helperObject.vat_included ? '1' : '0',
          vat_rate_id: this.state.helperObject.vat_rate_id,
          transfer_ids: this.props.checkedIds,
          filter: this.props.filter
        }

        body = (
          <React.Fragment>
            <p>{I18n.t('transfers-h3')}</p>
            <div className="flex-row center">
              <div className="col text-center">
                <Input
                  object={this.state.helperObject}
                  type="checkbox"
                  name="vat_included"
                  label={I18n.t('activerecord.attributes.transfer.value_with_vat')}
                  onChange={this.handleHelperInputChange.bind(this)}
                />
              </div>

              <div className="col">
                <Input
                  object={this.state.helperObject}
                  type="select"
                  name="vat_rate_id"
                  options={this.props.settings.special ? this.props.settings.special.options : []}
                  label="false"
                  onChange={this.handleHelperInputChange.bind(this)}
                />
              </div>
            </div>
          </React.Fragment>
        )

        footer = (
          <React.Fragment>
            <button className="btn btn-lg btn-default pull-left" data-dismiss="modal" type="button">
              {I18n.t('cancel')}
            </button>

            <div className="btn-group">
            <a
              onClick={(e) => jQuery('#modal').modal('hide')}
              href={window.appData.new_invoice_path + '?' + jQuery.param(params)}
              className="btn btn-lg btn-primary ajax-popup"
              data-popsize="middle"
            >
              {I18n.t('continue')}
            </a>

            <button className="btn btn-primary btn-lg dropdown-toggle" data-toggle="dropdown">
              <span className="caret caret-down"></span>
            </button>
            <ul className="dropdown-menu dropdown-menu-right">
              <li>
                <a
                  onClick={(e) => jQuery('#modal').modal('hide')}
                  href={window.appData.new_invoice_path + '?' + jQuery.param(Object.assign({}, params, {merge: 1}))}
                  className="ajax-popup"
                  data-popsize="middle"
                >
                  {I18n.t('merge')}
                </a>
              </li>
              <li>
                <a
                  onClick={(e) => jQuery('#modal').modal('hide')}
                  href={window.appData.new_invoice_path + '?' + jQuery.param(Object.assign({}, params, {merge: 2}))}
                  className="ajax-popup"
                  data-popsize="middle"
                >
                  {I18n.t('merge-per-project')}
                </a>
              </li>
            </ul>
            </div>
          </React.Fragment>
        )
        break
      case 'invoice-toggle-paid':
        body = (
          <React.Fragment>
            <p>{this.props.helperObject.paid ? I18n.t('invoice-toggle-paid-t2') : I18n.t('invoice-toggle-paid-t1')}</p>

            {!this.props.helperObject.paid && (
              <div className="form-group">
                <label className="control-label" htmlFor="modal_invoice_payment_date">
                  {I18n.t(`activerecord.attributes.invoice.payment_date`)}
                </label>
                <input
                  id="modal_invoice_payment_date"
                  type="date"
                  value={this.state.paymentDate}
                  onChange={(e) => this.setState({ paymentDate: e.target.value })}
                />
              </div>
            )}
          </React.Fragment>
        )

        footer = (
          <React.Fragment>
            <button className="btn btn-lg btn-default pull-left" data-dismiss="modal" type="button">
              {I18n.t('cancel')}
            </button>
            <a
              disabled={!this.state.paymentDate}
              onClick={this.toggleInvoicePaid.bind(this)}
              href="#"
              className="btn btn-lg btn-primary"
            >
              {I18n.t('continue')}
            </a>
          </React.Fragment>
        )
        break
      case 'share':
        body = (
          <SharedLinks
            key={`${this.props.scope_type}${this.props.scope_id}`}
            scope_type={this.props.scope_type}
            scope_id={this.props.scope_id}
          />
        )
        break
      default:
        body = this.props.body
        footer = this.props.footer
    }

    return (
      <div id="modal" className="modal fade" tabIndex="-1" role="dialog">
        <div className={classNames('modal-dialog modal-dialog-centered', this.props.size)} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {this.props.title}
                {this.props.beta ? (
                  <span className="beta" style={{ marginLeft: 4 }}>
                    beta
                  </span>
                ) : null}
              </h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">{body}</div>
            {footer ? <div className="modal-footer">{footer}</div> : null}
          </div>
        </div>
      </div>
    )
  }
}

export default Modal
